import { useParams } from 'react-router-dom';

import { InventoryViewTabs } from '../_components/InventoryViewTabs';
import { WORKLOAD_VIEWS } from '../_constants';
import { useInventoryWorkloadsViewLocation } from '../_hooks/useInventoryWorkloadsViewLocation';
import { buildInventoryWorkloadsViewPath } from '../navigation';

export const InventoryWorkloadsTabs = () => {
  const { clusterId } = useParams<{ clusterId: string }>();
  const { category } = useInventoryWorkloadsViewLocation();

  if (!clusterId) {
    return null;
  }

  return (
    <InventoryViewTabs
      testId="workloads-view-tabs"
      items={[
        {
          value: WORKLOAD_VIEWS.DASHBOARD,
          label: 'Dashboard',
          pathname: buildInventoryWorkloadsViewPath({
            clusterId,
            category,
            view: WORKLOAD_VIEWS.DASHBOARD,
          }),
          testId: 'workloads-dashboard-tab',
        },
        {
          value: WORKLOAD_VIEWS.LIST,
          label: 'List',
          pathname: buildInventoryWorkloadsViewPath({
            clusterId,
            category,
            view: WORKLOAD_VIEWS.LIST,
          }),
          testId: 'workloads-list-tab',
        },
      ]}
    />
  );
};
